module.exports = __webpack_public_path__ + "static/img/ElevatorPitch.5faa2ab7.jpg";